import * as React from 'react';

class InfoSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon info-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M8.43881 1.48185C9.82688 1.48185 11.1838 1.89346 12.3379 2.66464C13.4921 3.43581 14.3916 4.53191 14.9228 5.81432C15.454 7.09674 15.593 8.50787 15.3222 9.86927C15.0514 11.2307 14.383 12.4812 13.4014 13.4627C12.4199 14.4442 11.1694 15.1127 9.808 15.3835C8.44659 15.6543 7.03546 15.5153 5.75305 14.9841C4.47063 14.4529 3.37453 13.5533 2.60336 12.3992C1.83219 11.2451 1.42058 9.88816 1.42058 8.50008C1.42058 6.63873 2.16 4.85362 3.47617 3.53744C4.79234 2.22127 6.57746 1.48185 8.43881 1.48185ZM8.43881 0.479248C6.85244 0.479248 5.30169 0.949662 3.98267 1.831C2.66365 2.71234 1.6356 3.96503 1.02852 5.43064C0.421443 6.89626 0.262604 8.50898 0.57209 10.0649C0.881575 11.6208 1.64549 13.0499 2.76722 14.1717C3.88895 15.2934 5.31813 16.0573 6.87402 16.3668C8.42991 16.6763 10.0426 16.5174 11.5082 15.9104C12.9739 15.3033 14.2265 14.2752 15.1079 12.9562C15.9892 11.6372 16.4596 10.0865 16.4596 8.50008C16.4596 6.37282 15.6146 4.33269 14.1104 2.8285C12.6062 1.3243 10.5661 0.479248 8.43881 0.479248Z"
          fill="white"
        />
        <ellipse cx="8.4401" cy="4.85429" rx="0.729167" ry="0.729167" fill="white" />
        <rect x="7.71094" y="7.04175" width="1.45833" height="5.83333" rx="0.729167" fill="white" />
      </svg>
    );
  }
}

export default InfoSvg;
